import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { TaskTemplateResponse } from '../../../types/TaskTemplate';

type UseGetAllTaskTemplateParams = {
  page?: number;
  per_page?: number;
  search?: string,
  filters?: {
    archived?: boolean;
  };
};

export type UseGetAllTaskTemplateProps = {
  params?: UseGetAllTaskTemplateParams;
  enabled?: boolean;
};

export const fetchAllTaskTemplate = async ({ params }: UseGetAllTaskTemplateProps) => {
  const response = await CustomAxios.get<TaskTemplateResponse>(`task_templates`, { params });
  const { data } = response;
  return data;
};

export function useGetAllTaskTemplate({ params, enabled = true }: UseGetAllTaskTemplateProps) {
  const queryKey: any = [queryKeys.allTaskTemplates, params];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchAllTaskTemplate({ params }),
    placeholderData: keepPreviousData,
  });
  return query;
}
